import type React from 'react';

import { ErrorPageContainer } from './ErrorPage';

export const NotFoundContainer: React.FC = () => {
	return <ErrorPageContainer status={404} />;
};
